module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921075649_T.5b5b5c8f.jpg";